import type { Dict } from './types';

/**
 * A utility for getting a new object with a subset of keys of the source object
 *
 * @param object - souce object
 * @param keys - list of keys to be removed
 * @returns an object where the keys from the `keys param` have been omited
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function omit<T extends Dict<any>, K extends keyof T>(object: T, keys: K[]): Omit<T, K> {
  const result: Dict = {};

  Object.keys(object).forEach((key) => {
    if (keys.includes(key as K)) return;
    result[key] = object[key];
  });

  return result as Omit<T, K>;
}

/**
 * A utility for getting a new object with a subset of keys of the source object
 *
 * @param object - souce object
 * @param keys - list of keys
 * @returns an object consisting of keys from in the `keys param` with their corresponding values from the source object
 */
export function pick<T extends Dict<unknown>, K extends keyof T>(object: T, keys: K[]): Pick<T, K> {
  const result = {} as Pick<T, K>;

  keys.forEach((key) => {
    if (key in object) {
      result[key] = object[key];
    }
  });

  return result;
}
